"use strict";
exports.__esModule = true;
exports.CategoryLabel = void 0;
var SideNav_1 = require("@cjdev-internal/visual-stack/lib/components/SideNav");
var react_redux_1 = require("react-redux");
var actions_1 = require("../../actions");
exports.CategoryLabel = (0, react_redux_1.connect)(function (state) { return ({
    collapsed: (0, actions_1.selectCollaspedStateFromSideNav)(state)
}); }, null)(SideNav_1.CategoryLabel);
